export default __webpack_public_path__ + "static/media/visiretail-logo-splashscreen.a7682c28.svg";